// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Home as RawHome } from "lucide-react";
export const Home = /* @__PURE__ */ createIcon(RawHome, "Home", 2);
